import { useState } from 'react';
import { HeaderAndMetadata } from '@kw/quokka-ui';
import _ from 'lodash';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { MetadataPanel } from './MetadataPanel';
import { formatManagementDisplay } from '../../../utils/formatManagementDisplay';
import { formatAppSourceDisplay } from '../../../utils/formatAppSourceDisplay';
import { getSubstitutedVersionDisplay } from '../appVersionDisplay';

export function GuardianReportHeaderAndMetadata({ appName, appId, appVersion, os, iconUrl, appDetails, appAnalysis, tag, threatScore }) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const { guardianReportThreatScore } = useFlags();

  return (
    <>
      <HeaderAndMetadata
        appName={appName}
        packageName={appId}
        platform={os}
        version={appVersion}
        appIconUrls={[iconUrl].filter(url => url)}
        viewMetadataOnClick={() => setIsPanelOpen(true)}
        substitutedVersion={getSubstitutedVersionDisplay(appDetails?.analyzedVersion)}
        submissionTag={formatManagementDisplay(appAnalysis?.management)}
        sourceTag={formatAppSourceDisplay(appAnalysis?.appSource)}
        submittedAt={appAnalysis?.dateSubmitted}
        tag={tag}
        {...(guardianReportThreatScore ? { score: threatScore } : {})}
      />
      <MetadataPanel isOpen={isPanelOpen} setIsOpen={setIsPanelOpen} appDetails={appDetails || {}} appAnalysis={appAnalysis} />
    </>
  );
}
